import React from 'react';
import '../styles/Contact.css';

const Contact = () => {
  
  const [isLaunching, setIsLaunching] = React.useState(false);

  return (
    <div className={`contact container ${isLaunching ? 'blurred' : ''}`}>
      {isLaunching && (
        <div className="overlay">
          <div>
            <h2>Coming Soon</h2>
          </div>
        </div>
      )}
      <h1>Contact Us</h1>
      <form className="contact-form">
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" required></textarea>
        </div>
        <button type="submit" className="btn">Send Message</button>
      </form>
    </div>
  );
};

export default Contact;
